<template>
    <v-app ref="main" id="mainId">
        <AppMenuMobile :items="navMenuGuestItems" v-if="withMenu && isGuest === true"></AppMenuMobile>
        <AppMenuMobile :items="navMenuItemsWL" v-else-if="withMenu && isGuest === false && utils.getPlatform() !== $const.PLATFORM_TRADEBALL"></AppMenuMobile>
        <AppMenuMobile :items="navMenuItems" v-else-if="withMenu && isGuest === false && utils.getPlatform() === $const.PLATFORM_TRADEBALL"></AppMenuMobile>

        <AppMenuGuest v-if="withMenu && isGuest === true"></AppMenuGuest>
        <AppMenuWLPlayer ref="menuwl" v-else-if="withMenu && isGuest === false && utils.getPlatform() !== $const.PLATFORM_TRADEBALL"></AppMenuWLPlayer>
        <AppMenuTBPlayer ref="menuTb" v-else-if="withMenu && isGuest === false && utils.getPlatform() === $const.PLATFORM_TRADEBALL"></AppMenuTBPlayer>

        <v-main>
            <v-container fluid class="pa-0">
                <v-progress-linear v-if="loading" color="tbGreen" indeterminate></v-progress-linear>
                <v-progress-linear v-else value="0" color="transparent" />

                <AppNotification v-if="withMenu && isGuest === false"></AppNotification>

                <router-view></router-view>

                <AppEvent ref="event"></AppEvent>

                <AppMenuAccountChangeOrderSettingsDialog v-if="isGuest === false" ref="changeOrderSettingsDialog"></AppMenuAccountChangeOrderSettingsDialog>

                <v-snackbars multiLine timeout="5000" color="green" right top :objects.sync="objects" class="main-snackbar">
                    <template v-slot:default="{ index, message }">
                        <v-row v-if="objects[index].icon">
                            <v-col cols="2" class="my-auto" :class="objects[index].showCloseButton ? 'text-center' : 'text-right'">
                                <v-icon class="snackbar" :color="$vuetify.theme.dark ? '#b5bac1' : 'white'">
                                    {{ objects[index].icon }}
                                </v-icon>
                            </v-col>
                            <v-col class="px-0 my-auto">
                                <span v-html="message"></span>
                            </v-col>
                        </v-row>
                        <span v-else v-html="message"></span>
                    </template>
                    <template v-slot:action="{ index, close }">
                        <span>
                            <v-btn class="main-snackbar-button" v-if="objects[index].showCloseButton" text @click="close()">
                                {{ $t('common.close') }}
                            </v-btn>
                        </span>
                    </template>
                </v-snackbars>
            </v-container>
        </v-main>
    </v-app>
</template>

<style scoped></style>

<script>
    import { eventBus } from '~/app';
    import AppMenuTBPlayer from './menu/AppMenuTBPlayer';
    import AppNotification from 'Pages/core/notification/AppNotification';
    import AppMenuWLPlayer from './menu/AppMenuWLPlayer';
    import AppMenuGuest from './menu/AppMenuGuest';
    import VSnackbars from 'v-snackbars';
    import { mapState } from 'vuex';
    import constants from 'Helpers/constants';
    import AppMenuMobile from 'Components/menu/AppMenuMobile.vue';
    import AppEvent from 'Pages/core/event/AppEvent';
    import AppMenuAccountChangeOrderSettingsDialog from 'Components/menu/AppMenuAccountChangeOrderSettingsDialog.vue';

    export default {
        name: 'App',
        components: {
            AppMenuAccountChangeOrderSettingsDialog,
            AppEvent,
            AppMenuMobile,
            AppMenuGuest,
            AppMenuTBPlayer,
            AppNotification,
            AppMenuWLPlayer,
            'v-snackbars': VSnackbars,
        },
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        created() {
            document.addEventListener('visibilitychange', () => {
                console.log(document.hidden ? 'Tab is Inactive' : 'Tab is Active');

                this.$store.commit('AppModule/setIsBrowserTabInactive', document.hidden, { root: true })

                if (document.hidden === false) {
                    const browserTabInactiveTimeSec = (Date.now() - this.lastBrowserTabInactive) / 1000;
                    this.lastBrowserTabInactive = null
                    eventBus.$emit('browserTabVisibilityChanged', { isBrowserTabInactive: false, browserTabInactiveTimeSec: browserTabInactiveTimeSec });
                } else {
                    eventBus.$emit('browserTabVisibilityChanged', { isBrowserTabInactive: true });
                    this.lastBrowserTabInactive = Date.now();
                }
            });
        },
        data() {
            return {
                lastBrowserTabInactive: null
            }
        },
        computed: {
            ...mapState({
                withMenu: (state) => state.MenuModule.withMenu,
            }),
            objects: {
                get() {
                    return this.$store.state.AppModule.messages;
                },
                set(value) {
                    this.$store.commit('AppModule/setMessages', value);
                },
            },
            isGuest() {
                return this.user && this.user.type === constants.USER_TYPE_GUEST_ID;
            },

            user() {
                return this.$store.getters['UserModule/getUser'];
            },

            loading() {
                return this.$store.getters['PageModule/getLoading'];
            },

            navMenuItems: {
                get() {
                    return this.$store.getters['MenuModule/getNavMenuItems'];
                },
            },
            navMenuGuestItems: {
                get() {
                    return this.$store.getters['MenuModule/getNavMenuGuestItems'];
                },
            },
            navMenuItemsWL: {
                get() {
                    return this.$store.getters['MenuModule/getNavMenuItemsWL'];
                },
            },
        },
    };
</script>
